import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

export interface AlertSecurityModalData {
  title: string;
  primaryText: string;
  secondaryText: string;
  customHTML?: string;
  timer?: boolean;
}

@Component({
  selector: 'app-alert-security-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './alert-security-modal.component.html',
  styleUrl: './alert-security-modal.component.scss'
})
export class AlertSecurityModalComponent {
  private dialog = inject(MatDialogRef<AlertSecurityModalComponent>);
  private translate = inject(TranslateService);
  public data = inject(MAT_DIALOG_DATA) as AlertSecurityModalData;

  public get isFrench(): boolean {
    return this.translate.currentLang === 'fr';
  }

  public seconds: number = 0;
  public minutes: number = 0;
  public timeLeft = 300000; // 5 minutes
  private intervalId: any;

  ngOnInit(): void {
    document.body.classList.add('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.removeAttribute('aria-hidden');
    }
    if (this.data?.timer) {
      this.startCountdown();
    }
  }

  ngOnDestroy() {
    document.body.classList.remove('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.setAttribute('aria-hidden', 'true');
    }
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  primary(): void {
    this.clearTimer();
    this.dialog.close('stay');
  }

  secondary(): void {
    this.clearTimer();
    this.dialog.close('logout');
  }

  beforeClose() {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
  }

  closeDialog(res?: any): void {
    this.beforeClose();
    this.dialog.close(res);
  }

  startCountdown(): void {
    this.updateTime();
    this.intervalId = setInterval(() => {
      this.timeLeft -= 1000;
      if (this.timeLeft <= 0) {
        this.timeLeft = 0;
        this.updateTime();
        this.secondary(); // auto logout on timeout
        return;
      }
      this.updateTime();
    }, 1000);
  }

  private updateTime(): void {
    const totalSeconds = Math.floor(this.timeLeft / 1000);
    this.minutes = Math.floor(totalSeconds / 60);
    this.seconds = totalSeconds % 60;
  }

  private clearTimer(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}
